export default class Kassaabschluss {
    public abschlussnr: number | null = null;
    public impfstelle_id: number | null = null;
    public datum: string | null = null;
    public anfangssaldo: number | null = null;
    public gesamtbetrag: number | null = null;
    public saldo: number | null = null;
    public zeitstempel: string | null = null;

    constructor(data?: Partial<Kassaabschluss>) {
        Object.assign(this, data);
    }
}
